import regression from 'regression';
import { getDates } from './stringOperations';
import { mean } from 'mathjs'

export function excludeSummerMonths(xLabels, yLabels) {
    // Exclude non summer months
    var data = []
    for (var ii = 0; ii < xLabels.length; ii++) {
        var month = xLabels[ii].getMonth()
        if (month >= 5 && month <= 8) {
            data.push([xLabels[ii].getTime() / 10000000000, yLabels[ii]])
        }
    }
    return data
}
export function calculateTrendSummerMonths(xLabels, yLabels) {
    /**
     * Calculates the trend value between 0 and 1 for a certain number values.
     */


    const data = excludeSummerMonths(xLabels, yLabels)


    // Dates don't work as X values for proper regression analysis
    let dataConvForRegression=[]
    data.forEach((el, index) =>{
        dataConvForRegression.push([index, el[1]])
    })

    const result = regression.linear(dataConvForRegression, { precision: 5 });


    /**
     * ​Result withholds:
     * equation: Array [ 0.00386, 0.25919 ]
     * points: Array(24) [ (2) […], (2) […], (2) […], … ]
     * predict: function predict(x)
     * r2: 0.07567
     * string: "y = 0.00386x + 0.25919"
     */

    return result

}

export function getMinMaxTime(dates) {
    let min = null
    let max = null
    dates.forEach((date, index) => {
        // 👇️ getMonth returns integer from 0(January) to 11(December)
        if (min === null) {
            min = date.getTime()
        } else if (min > date.getTime()) {
            min = date.getTime()
        }

        if (max === null) {
            max = date.getTime()
        } else if (max < date.getTime()) {
            max = date.getTime()
        }

    });
    return { min, max }

}

export function getRechartsTrendObjects(dates, values) {
    //get Trend
    var xLabels = dates
    var yLabels = Object.values(values)
    const result = calculateTrendSummerMonths(xLabels, yLabels)
    const trendSlope = result.equation[0]


    // !!! No way to fit an accurate trendline, since all points are shown but only few are taken into consideration
    const summerData = excludeSummerMonths(xLabels, yLabels)
    var summerDataValues = []

    summerData.forEach(
        function (item, index) {
            summerDataValues.push(item[1])
        }
    )

    // const trendValueAtXMin = mean(summerDataValues)
    const trendValueAtXMin = result.equation[1] //== intercept
    const trendValueAtXMax = (trendSlope * summerDataValues.length) + trendValueAtXMin

    let { min, max } = getMinMaxTime(dates)

    const minPoint = { date: min, trend: trendValueAtXMin }
    const maxPoint = { date: max, trend: trendValueAtXMax }
    return { minPoint, maxPoint }
}